import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_NOTIFICATION]: (state, item) => addOrUpdateItem(state, item),
    [types.ADD_OR_UPDATE_NOTIFICATION_COUNT]: (state, count) => state.unreadCount = count,
    [types.REMOVE_NOTIFICATION]: (state, item) => removeItem(state, item),
    
}
